import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-show-testimonials-content-modal-base',
  templateUrl: './show-testimonials-content-modal-base.component.html',
  styleUrls: ['./show-testimonials-content-modal-base.component.scss']
})

export class ShowTestimonialsContentModalBaseComponent implements OnInit {
  public name: string;
  public content: string;

  constructor(
    public dialogRef: MatDialogRef<ShowTestimonialsContentModalBaseComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Inject(DOCUMENT) private document: any
    ) {
      dialogRef.afterClosed().subscribe(result => {
        this.document.body.classList.remove('no-scroll');
      });
    }

  ngOnInit(): void {
    this.name = this.dialogData.name;
    this.content = this.dialogData.content;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-testimonials-content-modal-base/show-testimonials-content-modal-base.component.ts